import * as Matter from 'matter-js';
import type { SceneDef } from './types';
import { createGround } from './util';

export const springMass: SceneDef = {
  labelKey: 'scene.springMass',
  defaultPlaying: true,
  params: [
    { id: 'mass', labelKey: 'dim.mass', min: 0.5, max: 10, step: 0.5, value: 2 },
    // Stiffness range biased low: 0.2 is so rigid the spring barely oscillates.
    // 0.005–0.05 gives visible bounce with finer resolution.
    { id: 'spring', labelKey: 'dim.spring', min: 0.005, max: 0.05, step: 0.002, value: 0.02 },
    { id: 'damping', labelKey: 'dim.damping', min: 0, max: 0.05, step: 0.002, value: 0.01 },
    { id: 'length', labelKey: 'dim.length', min: 80, max: 220, step: 10, value: 140 },
  ],
  build({ world, dims, bounds }) {
    const anchorX = bounds.width * 0.5;
    const anchorY = bounds.height * 0.22;
    const massX = anchorX;
    const massY = anchorY + dims.length! + 60;

    const ground = createGround(bounds);

    const bob = Matter.Bodies.rectangle(massX, massY, 50, 50, {
      mass: dims.mass!,
      frictionAir: dims.damping!,
    });

    const spring = Matter.Constraint.create({
      pointA: { x: anchorX, y: anchorY },
      bodyB: bob,
      length: dims.length!,
      stiffness: dims.spring!,
      damping: dims.damping!,
      label: 'spring',
    });

    const bodies = [ground, bob];
    const constraints = [spring];
    Matter.World.add(world, [...bodies, ...constraints]);

    return {
      bodies,
      constraints,
      drawOverlay(ctx) {
        ctx.save();
        ctx.fillStyle = '#444';
        ctx.fillRect(anchorX - 25, anchorY - 8, 50, 8);
        ctx.restore();
      },
      dispose() {
        Matter.World.remove(world, [...bodies, ...constraints]);
      },
    };
  },
};
